import React from 'react';
import ErrorPage from 'pages/ErrorPage';
import AccessDeniedPage from 'pages/AccessDeniedPage/AccessDeniedPage';
import LinksManagementPage from 'pages/LinksManagement';
import ImportLogPage from 'pages/ImportLogPage';
import LinkForm from 'pages/LinkForm';
import ToolsManagementPage from 'pages/ToolsManagement';
import ToolForm from 'pages/ToolForm';
import bootConfig from 'utils/bootConfig';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import {
  createLinkLoader,
  editLinkLoader,
  createToolLoader,
  editToolLoader,
} from './routeLoaders';

const router = createBrowserRouter([
  {
    // Root path - Defaults to Links Management
    path: '/',
    element: <Navigate to="/ltimanagement/links" replace />,
    errorElement: <ErrorPage />,
  },
  {
    // Links Management
    path: '/ltimanagement',
    element: <Navigate to="/ltimanagement/links" replace />,
    errorElement: <ErrorPage />,
  },
  {
    // Links Management
    path: '/ltimanagement/links',
    element: <LinksManagementPage />,
    errorElement: <ErrorPage />,
  },
  {
    // Create Link Form ex. /ltimanagement/link/create
    path: '/ltimanagement/link/:path',
    element: <LinkForm isEditMode={false} isReadonly={false} />,
    errorElement: <ErrorPage />,
    loader: createLinkLoader,
  },
  {
    // Edit Link Form ex. /ltimanagement/link/123-456-7890/edit
    path: '/ltimanagement/link/:id/:path',
    element: (
      <LinkForm
        isEditMode
        isReadonly={bootConfig.authInfo.permissions.isReadonlyLinks}
      />
    ),
    errorElement: <ErrorPage />,
    loader: editLinkLoader,
  },
  {
    // Tools Management
    path: '/ltimanagement/tools',
    element: <ToolsManagementPage />,
    errorElement: <ErrorPage />,
    loader: createToolLoader,
  },
  {
    // Create Tool Form ex. /ltimanagement/tool/create
    path: '/ltimanagement/tool/:path',
    element: <ToolForm isEditMode={false} />,
    errorElement: <ErrorPage />,
    loader: createToolLoader,
  },
  {
    // Edit Tool Form ex. /ltimanagement/tool/123-456-7890/edit
    path: '/ltimanagement/tool/:id/:path',
    element: <ToolForm isEditMode />,
    errorElement: <ErrorPage />,
    loader: editToolLoader,
  },
  {
    // Import Log Page
    path: '/import-logs',
    element: <ImportLogPage />,
    errorElement: <ErrorPage />,
  },
  {
    // Access Denied Page
    path: 'ltiManagement/accessDenied',
    element: <AccessDeniedPage />,
    errorElement: <ErrorPage />,
  },
]);

export default router;
